import styled from 'styled-components'

export const Article = styled.article`
	max-width: 1180px;
	padding: 24px 24px;
	width: 100%;
	tab-size: 2;
	min-width: 0;

	@media only screen and (max-width: 1250px) {
		order: 1;
		padding: 24px 16px;
	}
`
